import { GenericLayout } from '@/components/layouts/GenericLayout/GenericLayout';
import { Head } from '@/components/seo/Head/Head';
import { GenericSuccessScreen } from '@/components/shared/GenericSuccessScreen/GenericSuccessScreen';
import { Button } from '@/components/ui/Button/Button';
import { paths } from '@/config/paths';
import { useTranslation } from 'react-i18next';
import { Link } from 'react-router';

export const SuccessStep = () => {
  const { t } = useTranslation('auth', { keyPrefix: 'register.successStep' });

  return (
    <GenericLayout>
      <Head title={t('seo.title')} />
      <GenericSuccessScreen
        title={t('title')}
        description={t('description')}
        illustration='workout'
        leftActionElement={
          <Button asChild>
            <Link to={paths.auth.login.path}>{t('button.label')}</Link>
          </Button>
        }
      />
    </GenericLayout>
  );
};
